import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import loadScript from 'lib/loadScript';

import styles from '../styles.module.scss';

export default class QzzrEmbed extends React.Component {
  static propTypes = {
    html: PropTypes.string,
    className: PropTypes.string,
  };

  static defaultProps = {
    html: '',
    className: '',
  };

  componentDidMount() {
    loadScript('//dcc4iyjchzom0.cloudfront.net/widget/loader.js');
  }

  render() {
    const { html, className } = this.props;
    return (
      /* eslint-disable react/no-danger */
      <div
        className={classNames(className, styles.usePresentation)}
        dangerouslySetInnerHTML={{ __html: html.replace(/http:\/\//, 'https://') }}
      />
      /* eslint-enable react/no-danger */
    );
  }
}
